const getStepIndex = (stepId, steps) => {
  if (stepId) {
    const stepIndex = steps?.findIndex((step) => step.id === stepId);
    if (stepIndex !== void 0 && stepIndex !== -1) {
      return stepIndex;
    }
  }
  return 0;
};
export {
  getStepIndex
};
//# sourceMappingURL=get-step-index.js.map
